export default __webpack_public_path__ + "static/media/activ8gamelogo.5e2ff911.png";